<template>
<v-main>
  <v-container>
    <v-row>
      <v-col>
      <template>    
        <v-card :loading="queuesLoading" flat class='settings-card' style='border: 3px solid #292961'>
          <template slot="progress">
            <v-progress-linear
              color="accent"
              height="5"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-title>Queues</v-card-title>
          <div v-for="queue in savedQueues" :key="queue.ast_queue_id">
          
          <v-card
            class="mx-auto"
            outlined
            max-width="95%"
          >
              <v-card-title>
                {{makeNice(queue.name)}}
              </v-card-title>
              <v-card-text>
                <v-card>
                  <v-card-actions>
                    <v-btn
                      color="primary"
                      icon
                      v-on:click="getQueueStats(queue)"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                  </v-card-actions>
                  <v-card-text>
                    <v-simple-table v-if="queue.Stats">
                        <thead>
                          <tr>
                            <th>Callers</th>
                            <th>Answered</th>
                            <th>Abandoned</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{queue.Stats.callers}}</td>
                            <td>{{queue.Stats.answered}}</td>
                            <td>{{queue.Stats.abandoned}}</td>
                          </tr>
                        </tbody>
                        <thead><tr>
                          <th>Avg Talk Time</th>
                          <th>Avg Hold Time&nbsp;&nbsp;</th>
                          <th>Longest Hold Time&nbsp;&nbsp;</th>  
                        </tr></thead>
                        <tbody>
                          <tr>
                            <td>{{round(queue.Stats.avg_talk_time)}}</td>
                            <td>{{round(queue.Stats.avg_hold_time)}}</td>
                            <td>{{round(queue.Stats.longest_hold_time)}}</td>
                          </tr>
                        </tbody>
                    </v-simple-table>
                  </v-card-text>
                  
                </v-card>
                
                <v-row>
                  <v-col>
                    <v-card>
                      <v-card-text>
                        <u>Callers Waiting</u>
                      </v-card-text>
                      <v-card-text>
                        <v-menu v-for="caller in queue.callersWaiting"
                          v-model="caller.menu"
                          :close-on-content-click="false"
                          :nudge-width="200"
                          :key="caller.Uniqueid" 
                          offset-x
                        >
                          <template v-slot:activator="{ on, attrs }">
                            
                            <v-chip
                              class="pa-1 ma-1"  
                              v-on:click="callWaitingClick(caller)"
                              v-bind:color="callerColour(caller)"
                            >
                            {{caller.CallerIDNum}} {{caller.CallerIDName}} ({{caller.timer.timePassed}})
                          </v-chip>
                          
                          </template>
                           <v-card>
                            <v-card-actions class="justify-center">
                              <v-btn
                                v-on:click="takeCaller(caller)"
                              > Pickup Caller
                              </v-btn>
                              <v-btn
                                    v-on:click="agentHangup(caller)"
                                  > Hangup
                              </v-btn>
                            </v-card-actions>
                           </v-card>
                        </v-menu>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card>
                      <v-card-text>
                        <u>Agents</u>
                      </v-card-text>
                      <v-card-text>
                        <v-row v-for="device in queue.AstQueueDevices" :key="device.device_id" 
                          v-on:click="deviceClicked(device)"
                          v-bind:class="{ Paused: deviceIsPaused(queue, device), InUse: deviceStatus(device) == 'In use', OnHold: deviceStatus(device) == 'On Hold', Busy: deviceStatus(device) == 'Busy', Ringing: deviceStatus(device) == 'Ringing', RingingInUse: deviceStatus(device) == 'Ringing in use', NotInUse: deviceStatus(device) == 'Busy', Ringing: deviceStatus(device) == 'Ringing', NotInUse: deviceStatus(device) == 'Not in use', Unknown: deviceStatus(device) == 'Unknown'}"
                          no-gutters
                          class="ma-0 pa-0"
                        >
                          
                            <v-col class="ma-0 pa-0">{{device.device_name}}</v-col>
                        <!--  
                          <span v-for="sd in device.Sipdevices" :key="sd.name">
                            {{sd.name}} - {{sd.Paused}}<br>
                          </span>
                        -->  
                          <v-col v-if="device.Caller" class="ma-0 pa-0">
                            <v-menu
                              v-model="device.Caller.menu"
                              :close-on-content-click="false"
                              :nudge-width="200"
                              :key="device.Caller.Uniqueid" 
                              offset-x
                            >
                              <template v-slot:activator="{ on, attrs }">
                                
                                <v-chip
                                  class="pa-1 ma-1"  
                                  v-on:click="device.Caller.menu = true"
                                  color="green"
                                >
                                {{device.Caller.ConnectedLineNum}} {{device.Caller.ConnectedLineName}} 
                              </v-chip>
                              
                              </template>
                              <v-card v-if="!showNotSupervisor">
                                <v-card-actions class="justify-center">
                                  <v-btn
                                    v-on:click="agentBarge(device.Caller, device, queue)"
                                  > Join
                                  </v-btn>
                                  <v-btn
                                    v-on:click="agentSpy(device.Caller, device, queue)"
                                  > Listen
                                  </v-btn>
                                  <v-btn
                                    v-on:click="agentHangup(device.Caller, device, queue)"
                                  > Hangup
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                              <v-card v-if="showNotSupervisor">
                                <v-card-text>
                                  You need to be a queue supervisor to use this feature.
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                  <v-btn
                                    v-on:click="showNotSupervisor = false"
                                  > OK
                                  </v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-menu>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card>
                      <v-card-text>
                        <u>Abandoned Callers</u>
                      </v-card-text>
                      <v-card-text>
                        <span v-for="caller in queue.callersAbandoned" :key="caller.Uniqueid">
                          {{caller.CallerIDNum}} {{caller.CallerIDName}} - {{caller.HoldTime }}(s) - {{caller.Position}}<br>
                        </span>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
               <v-btn
                  color="primary"
                  text
                  v-if="!inQueue(queue)"
                  v-on:click="joinQueue(queue)"
                >
                  Join Queue
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  v-if="inQueue(queue)"
                  v-on:click="leaveQueue(queue)"
                >
                  Leave Queue
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  v-if="inQueue(queue) && !paused(queue)"
                  v-on:click="pauseQueue(queue)"
                >
                  Pause
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  v-if="inQueue(queue) && paused(queue)"
                  v-on:click="continueQueue(queue)"
                >
                  Continue
                </v-btn>
              </v-card-actions>
          </v-card>
          <br>
          </div>
          <br><br><br><br><br><br><br><br><br><br>
          <v-card-actions>
            <v-btn
                  color="primary"
                  text
                  v-on:click="pauseAll"
                >
                  Pause All Queues
            </v-btn>
            <v-btn
                  color="primary"
                  text
                  v-on:click="continueAll"
                >
                  Continue All Queues
            </v-btn>
            <v-btn
                  color="primary"
                  text
                  v-on:click="getQueues"
                >
                  Reset
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
      </v-col>
    </v-row>
  </v-container>



</v-main>
</template>



<script >
import { checkServerIdentity } from 'tls';
import { mapState } from 'vuex';
import Common from '../mixins/common.vue';

import Helpers from '../vuex/helpers.js';





export default {
  data: function() {
    return {
      showNotSupervisor: false,
    }
  },
  mixins: [Common],
  props: {
  },
  computed: {
    ...mapState([

      'deviceId',
      'device', 
      'isDevelopment',
      'number',
      'user',
      'userId',
    ]),
    queues: {
      get: function() {
        return this.$store.state.queues.queues;
      }
    },
    savedQueues: function() {
      let arr = [];
      for (let i=0;i<this.queues.length;i++) {
        let q = this.queues[i];        
        arr.push(q);
      }
      return arr;
    },
    queuesLoading: {
      get: function () {
        return this.$store.state.conference.queuesLoading;
      }
    },
    
    
  },
  components: {
  },
  methods: {
    round: function(val) {
      return Math.round(val*100)/100;
    },
    getQueues: function() {
      this.$store.dispatch('queues/getQueues');
    },
    joinQueue: function(queue) {
      this.$store.dispatch('queues/queueMemberAdd', {queue, device: this.device, penalty: 1, paused: 0});
    },
    leaveQueue: function(queue) {
      this.$store.dispatch('queues/queueMemberLeave', {queue, device: this.device});
    },
    pauseQueue: function(queue) {
      this.$store.dispatch('queues/queueMemberPause', {queue, device: this.device});
    },
    callWaitingClick(caller) {
      caller.menu=1;
      console.log(caller);
    },
    
    pauseAll: function() {
      for (let i=0;i<this.savedQueues.length;i++) {
        let queue = this.savedQueues[i];
        this.$store.dispatch('queues/queueMemberPause', {queue, device: this.device});
      }
    },
    continueQueue: function(queue) {
      this.$store.dispatch('queues/queueMemberContinue', {queue, device: this.device});
    },
    continueAll: function() {
      for (let i=0;i<this.savedQueues.length;i++) {
        let queue = this.savedQueues[i];
        this.$store.dispatch('queues/queueMemberContinue', {queue, device: this.device});
      }
    },
    takeCaller: function(caller) {
      console.log('takeCaller', caller);
      this.$store.dispatch('queues/takeCaller', {caller, device: this.device});
    },
    agentSpy: function(caller, agentDevice, queue) {
      if (this.iAmSupervisor(queue)) {
        this.$store.dispatch('queues/agentSpy', {caller, device: this.device, agentDevice: agentDevice});
      } else {
        this.showYouMustBeSupervisor();
      }
    },
    agentBarge: function(caller, agentDevice, queue) {
      if (this.iAmSupervisor(queue)) {
        this.$store.dispatch('queues/agentBarge', {caller, device: this.device, agentDevice: agentDevice});
      } else {
        this.showYouMustBeSupervisor();
      }
    },
    getQueueStats: function(queue) {
      queue.Stats.loading = true;
      this.$store.dispatch('queues/getQueueStats', {queue});
    },
    agentHangup: function(caller, agentDevice, queue) {
      if (this.iAmSupervisor(queue)) {
        this.$store.dispatch('queues/agentHangup', {caller, device: this.device});
      } else {
        this.showYouMustBeSupervisor();
      }
    },
    showYouMustBeSupervisor: function () {
      //set showNotSupervisor to true for 5 seconds then set it to false
      this.showNotSupervisor = true;
      setTimeout(() => {
        this.showNotSupervisor = false;
      }, 5000);
    },
    iAmSupervisor: function(astQueue) {
      console.log('checking if i am supervisor');
      if (astQueue.QueueSupervisors) {
        for (let i=0;i<astQueue.QueueSupervisors.length;i++) {
          let supervisor = astQueue.QueueSupervisors[i];
          if (supervisor.user_id == this.$store.state.user.user_id) {
            return true;
          }
        }
      }
      console.log('i am not supervisor');
      return false;
    },
    callerColour: function (caller) {
      // switch statement on caller.timer.timePassed
      if (caller.timer.timePassed < 30) {
        return "#4CAF50"; // green
      } else if (caller.timer.timePassed < 60) {
        return "#009688"; // teal
      } else if (caller.timer.timePassed < 120) {
        return "#9C27B0"; // purple
      } else if (caller.timer.timePassed < 240) {
        return "#FF9800"; // orange
      } else if (caller.timer.timePassed < 300) {
        return "#03A9F4"; // teal
      } else {
        return "#03A9F4";
      }
    },
    inQueue: function(queue) {
      if (queue) {
        if (!queue.AstQueueDevices) return false;
        for (let i=0;i<queue.AstQueueDevices.length;i++) {
          let qd = queue.AstQueueDevices[i];
          if (qd.device_id == this.deviceId) {
            return true;
          }
        }
      }
      return false;
    },
    makeNice: function(str) {
      // get the remainder of a string after the first hyphen
      if (!str) return '';
      return str.substring(str.indexOf('-')+1);
    },
    subscribeToQueues: function() {
      console.log('subscribeToQueues');
      this.$store.dispatch('queues/subscribeToQueues');
    },
    deviceClicked: function(device) {
      console.log('deviceClicked', device);
    },
    deviceStatus: function(device) {

        if (this.checkSipdevicesForStatus(device.Sipdevices, 'In use')) {
          return 'In use';
        } else if (this.checkSipdevicesForStatus(device.Sipdevices, 'On hold')) {
          return 'On hold';
        } else if (this.checkSipdevicesForStatus(device.Sipdevices, 'Busy')) {
          return 'Busy';
        } else if (this.checkSipdevicesForStatus(device.Sipdevices, 'Ringing')) {
          return 'Ringing';
        } else if (this.checkSipdevicesForStatus(device.Sipdevices, 'Ringing in use')) {
          return 'Ringing in use';
        } else if (this.checkSipdevicesForStatus(device.Sipdevices, 'Not in use')) {
          device.Caller = null;
          return 'Not in use';
        } else {
          return 'Unknown';
        }      
    },
    deviceIsPaused: function(queue, device) {
      if (!queue.AstQueueDevices) return false;
      if (!queue.AstQueueDevices.length) return false;
      for (let i=0;i<queue.AstQueueDevices.length;i++) {
        let qd = queue.AstQueueDevices[i];
        if (qd.device_id == device.device_id) {
          for (let i=0;i<qd.Sipdevices.length;i++) {
            let sd = qd.Sipdevices[i];
            if (sd.Paused) {
              console.log('paused', sd.Paused);
              if (sd.Paused == 1) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    paused: function(queue) {
      if (!queue.AstQueueDevices) return false;
      if (!queue.AstQueueDevices.length) return false;
      for (let i=0;i<queue.AstQueueDevices.length;i++) {
        let qd = queue.AstQueueDevices[i];
        if (qd.device_id == this.deviceId) {
          for (let i=0;i<qd.Sipdevices.length;i++) {
            let sd = qd.Sipdevices[i];
            if (sd.Paused) {
              console.log('paused', sd.Paused);
              if (sd.Paused == 1) {
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    checkSipdevicesForStatus: function(sipdevices, status) {
      let helpers = new Helpers();
      for (let i=0;i<sipdevices.length;i++) {
        let sd = sipdevices[i];
        if (sd.Status) {
          if (helpers.memberStatusToText(sd.Status) == status) {
            return true;
          }
        } 
      }
      return false;
    }
  },
  mounted() {
    global.api.userAction('queues', null, 'webphone');
    
  }
  
};

</script>

<style scoped>

div[class*="col-"] {
  background: #fff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.row {
  margin-bottom: 0px;
}
.Paused {
  color: blue;
  text-decoration:line-through;
}
.InUse {
  color: red;
}
.OnHold {
  color: blue;
}
.Busy {
  color: red;
}
.Ringing {
  color: orange;
}
.RingingInUse {
  color: orange;
}
.NotInUse {
  color: green;
}
.Unknown {
  color: grey;
}
</style>
